import { INVALIDATE_QUERY_CACHE } from '../actions';
import { invalidateQueryClientCache } from '../../api/query-client-registry';

/**
 * The single seam between Redux and React Query. Thunks that mutate server
 * state dispatch `invalidateQueryCache(queryKey)`; this middleware is the only
 * place that reaches into the RQ client, so the coupling lives in one file and
 * shows up in Redux DevTools. No-ops (in the registry helper) when no client is
 * registered — e.g. widget-app, which bundles the thunks but never mounts RQ.
 */
export const invalidateQueryCacheMiddleware = () => next => action => {
  if (action.type === INVALIDATE_QUERY_CACHE) {
    invalidateQueryClientCache(action.payload.queryKey);
  }
  return next(action);
};

export const queryCacheMiddleware = [invalidateQueryCacheMiddleware];
